export default {
    journey: {
        singleForm: 'SingleForm',
        twoStageForm: 'TwoStageForm'
    },
    employmentStatus: {
        student: 'STUDENT',
        salariedPvtSector: 'SALARIED_PRIVATE_SECTOR',
        salariedPublicSector: 'SALARIED_GOVERNMENT_SECTOR',
        professional: 'PROFESSIONAL',
        selfEmployed: 'SELF_EMPLOYED_OR_FUNDED',
        retired: 'RETIRED'
    },
    go2ApiDecision: {
        declined: 'DECLINED',
        cancelled: 'CANCELLED',
        error: 'ERROR',
        pended: 'PENDED',
        fraudWN: 'FraudWN',
        approved: 'APPROVED'
    },
    stagesInTwoStage: {
        lmsDeclined: 'LMS-Declined',
        go2Pended: 'GO2Pended',
        go2Approved: 'GO2Approved',
        go2Declined: 'GO2Declined',
        genericError: 'GenericError',
        genericErrorForStage2: 'GenericErrorForStage2',
        error422: 'Error422',
        error422ForStage2: 'Error422ForStage2',
        limitExceeded: 'LimitExceeded'
    },
    validation: {
        addressPattern: /^[0-9a-zA-Z\s\-:',/]*$/,
        mobilePattern: /^[6-9][0-9]*$/,
        pinPattern: /^[0-9]*$/,
        cityPattern: /^[a-zA-Z ]*$/,
        namePattern: /^[a-zA-Z]+[a-zA-Z\s'-]*$/,
        ckycPattern: /^[0-9a-zA-Z]{14}/,
        companyPattern: /^[0-9a-zA-Z \s\-.&']*$/
    },
    prodUrl: {
        lmsProd: 'lmsindiainternet.americanexpress.com',
        mediaCampProd: 'mediacampaigns.americanexpress.com'
    },
    qaUrl: {
        lmsQA: 'lmsindiainternet-qa.americanexpress.com'
    },
    fraudWNCode: {
        codes: ['XA', 'XC', 'XD', 'XE', 'XF', 'XH', 'XL', 'XM', 'XN', 'XO', 'XQ', 'XR', 'XV', 'XX']
    },
    placeHolder: {
        addressline1: 'Block Number / Tower Number / Flat Number / House Number',
        addressline2: 'Apartment / Condominium Name / Road',
        addressline3: 'Area / Locality'
    },
    addressType: {
        home: 'HomeAddress',
        office: 'OfficeAddress'
    },
    platinumCard: 'platinumcard',
    go2ApiPurpose: {
        vkyc:'VIDEO_KYC'
    },
    go2Journey: {
        Journey1: 'Journey1',
        Journey2: 'Journey2',
        Journey3: 'Journey3',
        Journey4: 'Journey4',
    }
}